import React from "react";
import logo from "../../assets/images/logo.png";
import dayjs from "dayjs";
import parse from "html-react-parser";

const ReferBook = ({ data }: { data: any }) => {
  const sectionTitle = {
    fontSize: "15px",
    fontWeight: "bold",
    marginBottom: "6px",
    marginTop: "18px",
    color: "#222",
  };

  const row = {
    display: "flex",
    alignItems: "center",
    marginBottom: "6px",
    fontSize: "14px",
    padding: "0px 20px 0px 20px",
  };

  const label = {
    width: "120px",
    // fontWeight: 600,
    whiteSpace: "nowrap",
    color: "#333",
  };

  const value = {
    fontWeight: "bold",
    color: "#111",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "15px"
  };

  // FORMAT TIME UTILITY
  const formatTime = (time: string) => {
    if (!time) return "";
    const [hours, minutes] = time.split(":");
    const hour = parseInt(hours);
    const ampm = hour >= 12 ? "PM" : "AM";
    const displayHour = hour > 12 ? hour - 12 : hour === 0 ? 12 : hour;
    return `${displayHour}:${minutes} ${ampm}`;
  };

  return (
    <>
      <div
        style={{
          width: "100%",
          border: "1px solid #cfcfcf",
          fontFamily: "Arial, sans-serif",
          fontSize: "14px",
          lineHeight: 1.4,
        }}
      >
        {/* Organization Details */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: data?.organizationName ? "20px" : "",
            borderBottom: data?.organizationName ? "1px solid #cfcfcf" : "",
          }}
        >
          {data?.organizationName && (
            <div style={{ fontSize: "20px", fontWeight: "bold" }}>
              {data?.organizationName}
            </div>
          )}

          {/* Organization Address Details */}
          <div
            style={{
              textAlign: "center",
              paddingTop: "10px",
              fontSize: "13px",
              color: "#444",
            }}
          >
            <div>
              {[
                data?.address1,
                data?.address2,
                data?.city,
              ]
                .filter(Boolean)
                .join(", ")}{" "}
              {data?.postalCode
                ? ` - ${data?.postalCode}`
                : ""}
            </div>

            {(data?.mobileNumber ||
              data?.email) && (
                <div style={{ marginTop: "4px" }}>
                  {[
                    data?.mobileNumber
                      ? `Contact Number: ${data?.mobileNumber}`
                      : "",
                    data?.email
                      ? `Email: ${data?.email}`
                      : "",
                  ]
                    .filter(Boolean)
                    .join(", ")}
                </div>
              )}
          </div>
        </div>

        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "16px",
            padding: "20px 20px 0px 20px"
          }}
        >
          {/* Doctor Details */}
          <div>
            {data?.toDoctorName && (
              <div style={{ fontSize: "20px", fontWeight: "bold" }}>
                {data?.toDoctorName}
              </div>
            )}

            {data?.toDoctorQualification && (
              <div style={{ fontSize: "14px", marginTop: "2px", color: "#444" }}>
                ({data?.toDoctorQualification})
              </div>
            )}
          </div>

          {/* Clinic Name */}
          <div
            style={{
              textAlign: "right",
              fontWeight: "bold",
              fontSize: "16px",
              color: "#222",
              maxWidth: "45%",
              lineHeight: 1.2,
            }}
          >
            {data?.toLocationName}
          </div>
        </div>

        {/* Address Block */}
        <div
          style={{
            textAlign: "center",
            borderBottom: "1px solid #dcdcdc",
            borderTop: "1px solid #dcdcdc",
            paddingBottom: "10px",
            paddingTop: "10px",
            marginBottom: "10px",
            fontSize: "13px",
            color: "#444",
          }}
        >
          <div>
            {[
              data?.toLocationAddress1,
              data?.toLocationAddress2,
              data?.toLocationCity,
              data?.toLocationCountry,
            ]
              .filter(Boolean)
              .join(", ")}{" "}
            {data?.toLocationPostalCode
              ? ` - ${data?.toLocationPostalCode}`
              : ""}
          </div>

          {(data?.toLocationContactNumber ||
            data?.toLocationEmail) && (
              <div style={{ marginTop: "4px" }}>
                {[
                  data?.toLocationContactNumber
                    ? `Contact Number: ${data?.toLocationContactNumber}`
                    : "",
                  data?.toLocationEmail
                    ? `Email: ${data?.toLocationEmail}`
                    : "",
                ]
                  .filter(Boolean)
                  .join(", ")}
              </div>
            )}
        </div>

        {/* Available Date */}
        {data?.referBookAvailableDateJson && (() => {
          try {
            const dates = JSON.parse(data.referBookAvailableDateJson);
            if (dates?.length > 0) {
              return (
                <div
                  style={{
                    borderBottom: "1px solid #dcdcdc",
                    padding: "0px 20px 10px 20px",
                    fontSize: "13px",
                    color: "#444",
                  }}
                >
                  <div style={value}>
                    Next working day/hours:
                  </div>

                  {dates.map(
                    (item: any, index: number) => (
                      <div key={index} style={label}>
                        {item.dayName},{" "}
                        {dayjs(item.appointmentDate).format(
                          "MMM DD, YYYY"
                        )}{" "} - {item.timeSlot}
                        {/* - {formatTime(item.startTime)} to{" "}
                        {formatTime(item.endTime)} */}
                      </div>
                    ))}
                </div>
              );
            }
          } catch { }
          return null;
        })()}

        {/* Reference Date */}
        <div style={{ ...row, paddingTop: "15px" }}>
          <div style={label}>Ref Date:</div>
          <div style={value}>
            {data?.referDate
              ? dayjs(data.referDate).format("DD-MM-YYYY")
              : ""}
          </div>
        </div>

        {/* Patient Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            columnGap: "20px",
            marginTop: "12px",
          }}
        >
          <div style={row}>
            <div style={label}>Patient Name:</div>
            <div style={value}>
              {data?.forPatientFirstName} {data?.forPatientLastName}
            </div>
          </div>

          <div style={row}>
            <div style={label}>Patient Contact:</div>
            <div style={value}>{data?.forPatientMobileNumber}</div>
          </div>

          <div style={row}>
            <div style={label}>Gender / Age:</div>
            <div style={value}>
              {data?.forPatientGender}{" "}
              {(data?.forPatientAgeYear || data?.forPatientAgeMonth || data?.forPatientAgeDay) && " / "}
              {data?.forPatientAgeYear > 0 ? `${data.forPatientAgeYear}y ` : ""}
              {data?.forPatientAgeMonth > 0 ? `${data.forPatientAgeMonth}m ` : ""}
              {data?.forPatientAgeDay > 0 ? `${data.forPatientAgeDay}d` : ""}
            </div>
          </div>
        </div>

        {/* Reason for Reference */}
        {data?.reasonForReferenceColl?.length > 0 && (
          <div style={{ marginTop: "20px", borderTop: "1px solid #dcdcdc", padding: "0px 20px 0px 20px" }}>
            <div style={sectionTitle}>Reason for Reference</div>
            <div style={{ fontSize: "14px", color: "#222" }}>
              {data.reasonForReferenceColl
                .sort((a: any, b: any) => a.displayOrder - b.displayOrder)
                .map((i: any) => i.reasonForReferenceLabel)
                .join(", ")}
            </div>
          </div>
        )}

        {/* Clinical Notes */}
        {data?.clinicalNotes &&
          data.clinicalNotes.replace(/<[^>]*>/g, "").trim() !== "" && (
            <div
              style={{
                marginTop: "22px",
                borderTop: "1px solid #dcdcdc",
                padding: "0px 20px",
              }}
            >
              <div style={sectionTitle}>Clinical Notes</div>

              <div style={{ fontSize: "14px", color: "#222" }}>
                {parse(
                  data.clinicalNotes
                    ?.replace(/^<p>/, "")
                    ?.replace(/<\/p>$/, "")
                )}
              </div>
            </div>
          )}

        {/* Referred By */}
        {(data?.fromDoctorName || data?.fromDoctorQualification) && (
          <div
            style={{
              ...row,
              marginTop: "22px",
              borderTop: "1px solid #dcdcdc",
              padding: "20px 20px 0px 20px",
            }}
          >
            <div style={label}>Referred by Dr.:</div>
            <div style={value}>
              {data.fromDoctorName}
              {data.fromDoctorQualification
                ? ` (${data.fromDoctorQualification})`
                : ""}
            </div>
          </div>
        )}

        {/* Doctor Contact */}
        {data?.fromDoctorContactNumber && (
          <div style={{ ...row, paddingBottom: "20px" }}>
            <div style={label}>Contact Number:</div>
            <div style={value}>{data.fromDoctorContactNumber}</div>
          </div>
        )}
      </div>

      {/* Footer Branding */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "20px",
          gap: "6px",
          fontSize: "12px",
          color: "#444",
        }}
      >
        <span>Powered by</span>
        <img
          src={logo}
          alt="Footer Logo"
          style={{ height: 20, objectFit: "contain" }}
        />
      </div>
    </>
  );
};

export default ReferBook;
